import React from "react";

const MetaIcon = () => {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17132_52440)">
        <path
          d="M2.34723 9.67539C2.34723 10.5201 2.52602 11.1659 2.75971 11.5575C2.88424 11.7804 3.06358 11.9653 3.27949 12.0933C3.4954 12.2213 3.74019 12.2879 3.989 12.2862C4.58992 12.2862 5.13964 12.1326 6.19904 10.6153C7.04775 9.39972 8.04779 7.69731 8.72141 6.62227L9.86093 4.81005C10.6525 3.55148 11.5672 2.15239 12.6192 1.20098C13.4761 0.430018 14.4012 0 15.3323 0C16.8954 0 18.3843 0.937592 19.5238 2.69606C20.7709 4.62192 21.3785 7.04768 21.3785 9.551C21.3785 11.0392 21.0951 12.1326 20.6129 12.9965C20.1478 13.832 19.2367 14.6667 17.7092 14.6667V12.2862C19.0171 12.2862 19.3413 11.0422 19.3413 9.61857C19.3413 7.58981 18.8843 5.33836 17.8776 3.72963C17.1632 2.58855 16.2373 1.89131 15.2187 1.89131C14.1171 1.89131 13.2305 2.75134 12.2342 4.28482C11.7045 5.09955 11.1607 6.09243 10.5501 7.21278L9.878 8.4414C8.52778 10.9194 8.18578 11.4838 7.51067 12.4152C6.32961 14.0524 5.31918 14.6667 3.989 14.6667C2.41103 14.6667 1.41321 13.9594 0.798939 12.8936C0.290755 12.0251 0.0429688 10.8856 0.0429688 9.58709L2.34723 9.67539Z"
          fill="#0081FB"
        />
        <path
          d="M1.85938 2.86422C2.9158 1.17871 4.44036 0 6.18895 0C7.20161 0 8.20833 0.307155 9.25957 1.19867C10.4095 2.17005 11.6336 3.76956 13.1641 6.40572L13.7123 7.35176C15.0358 9.63393 15.7895 10.8073 16.2295 11.3617C16.7963 12.0727 17.1939 12.2831 17.7088 12.2831C19.0167 12.2831 19.3409 11.0392 19.3409 9.6155L21.3736 9.54946C21.3736 11.0376 21.0902 12.1311 20.608 12.995C20.1473 13.832 19.2363 14.6667 17.7088 14.6667C16.7592 14.6667 15.9179 14.4532 14.9876 13.5448C14.2724 12.8475 13.4363 11.6089 12.7931 10.4955L10.8798 7.18743C9.91984 5.52726 9.03923 4.28942 8.52957 3.73194C7.98058 3.12607 7.27654 2.39812 6.15186 2.39812C5.24158 2.39812 4.46855 3.05927 3.82163 4.07058L1.85938 2.86422Z"
          fill="url(#paint0_linear_17132_52440)"
        />
        <path
          d="M6.1523 2.39812C5.24202 2.39812 4.46899 3.05927 3.82208 4.07058C2.90734 5.49962 2.34723 7.6282 2.34723 9.67539C2.34723 10.5201 2.52602 11.1659 2.75971 11.5575L0.795229 12.8936C0.290755 12.0251 0.0429688 10.8856 0.0429688 9.58709C0.0429688 7.22583 0.669111 4.76475 1.85982 2.86422C2.91625 1.17871 4.4408 0 6.1894 0L6.1523 2.39812Z"
          fill="url(#paint1_linear_17132_52440)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_17132_52440"
          x1="4.66737"
          y1="6.95323"
          x2="19.359"
          y2="7.67009"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0064E1" />
          <stop offset="0.4" stopColor="#0064E1" />
          <stop offset="0.83" stopColor="#0073EE" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_17132_52440"
          x1="3.11581"
          y1="10.6736"
          x2="3.11581"
          y2="5.06806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop offset="1" stopColor="#0064E0" />
        </linearGradient>
        <clipPath id="clip0_17132_52440">
          <rect
            width="21.3333"
            height="14.6667"
            fill="white"
            transform="translate(0.0429688)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MetaIcon;
